<div class="row header">
	<div class="col-md-12 d-flex align-items-center">
		<button mat-icon-button (click)="toggleSidenav()" class="example-icon" aria-label="Example icon-button with menu icon">
			<mat-icon>menu</mat-icon>
		</button>

		<h1 class="m-0">{{ pageTitle }}</h1>
	</div>
</div>